import PropTypes from "prop-types";

import FilterBox from "components/listing-search/filter-box";
import FilterItems from "@/src/components/listing-search/filter-items";
import CategoryFilter from "components/listing-search/category-filter";

import styles from "./styles.module.css";

const FilterSidebar = ({
  listingData,
  categoryTree,
  listingCountItems,
  pageType,
  screenType,
  filters,
  isLoadingListingCategoryCount,
}) => {
  const { searchCriteria, total, listingCard, projectCards } = listingData || {};
  const totalCount = total || listingCard?.total || projectCards?.total || 0;

  return (
    <div className={styles.wrapper}>
      <FilterBox isTypeView>
        <div className={styles.title}>Kategoriler</div>
        <CategoryFilter
          listingCountItems={listingCountItems}
          criteria={searchCriteria}
          categoryTree={categoryTree}
          totalCount={totalCount}
          screenType={screenType}
          isLoadingListingCategoryCount={isLoadingListingCategoryCount}
        />
      </FilterBox>
      <FilterBox>
        <FilterItems criteria={searchCriteria} pageType={pageType} screenType={screenType} filters={filters} />
      </FilterBox>
    </div>
  );
};

FilterSidebar.propTypes = {
  categoryTree: PropTypes.array,
  listingData: PropTypes.object,
  listingCountItems: PropTypes.array,
  screenType: PropTypes.string,
  filters: PropTypes.object,
  pageType: PropTypes.string,
  isLoadingListingCategoryCount: PropTypes.bool,
};

export default FilterSidebar;
